module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form>\n   <div role="tabpanel">\n      <ul class="nav nav-tabs nav-fill nav-tabs-brand flex-column flex-md-row" role="tablist">\n         ';
 sections.forEach(function ( section, index ) { 
__p+='\n         ';
 var sectionId = htmlId( section.title + section.id ) 
__p+='\n         <li class="nav-item" role="tab">\n            <a id="'+
((__t=( sectionId ))==null?'':__t)+
'-tab" class="nav-link '+
((__t=( index === 0 && 'active' ))==null?'':__t)+
'" data-toggle="tab"\n               href="#'+
((__t=( sectionId ))==null?'':__t)+
'"\n               aria-controls="'+
((__t=( sectionId ))==null?'':__t)+
'"\n               aria-expanded="'+
((__t=( index === 0 ? 'true' : 'false' ))==null?'':__t)+
'"><h2>'+
((__t=( section.title ))==null?'':__t)+
'</h2></a>\n         </li>\n         ';
 }) /* end sections */ 
__p+='\n      </ul>\n\n      <div class="card-body">\n         <div class="tab-content">\n            ';
 sections.forEach(function ( section, index ) { 
__p+='\n            ';
 var sectionId = htmlId( section.title + section.id ) 
__p+='\n            <div class="tab-pane '+
((__t=( index === 0 && 'active' ))==null?'':__t)+
'" id="'+
((__t=( sectionId ))==null?'':__t)+
'" role="tabpanel"\n               aria-labelledby="'+
((__t=( sectionId ))==null?'':__t)+
'-tab">\n               <p class="lead">'+
((__t=( section.description ))==null?'':__t)+
'</p>\n               <div id="'+
((__t=( sectionId ))==null?'':__t)+
'-collapse" role="tablist">\n                  ';
 section.categories  && section.categories.forEach(function ( category, index ) { 
__p+='\n                  ';
 var categoryId = htmlId( category.title + category.id ) 
__p+='\n                  <div class="card border-primary ';
 if (index !== section.categories.length - 1 || !!section.interests) { 
__p+=' mb-3 ';
 } 
__p+='" role="tab">\n                     <div class="card-header bg-primary pb-2 px-3" id="'+
((__t=( categoryId ))==null?'':__t)+
'-heading">\n                        <a data-toggle="collapse" href="#'+
((__t=( categoryId ))==null?'':__t)+
'" aria-expanded="true"\n                           aria-controls="'+
((__t=( categoryId ))==null?'':__t)+
'"\n                           class="accordion-title-brand ';
 if (index !== 0) { 
__p+=' collapsed ';
 } 
__p+='">\n                           <h4>'+
((__t=( category.title ))==null?'':__t)+
'</h4>\n                        </a>\n                     </div>\n\n                     <div id="'+
((__t=( categoryId ))==null?'':__t)+
'" class="collapse '+
((__t=( index === 0 && 'show' ))==null?'':__t)+
'" role="tabpanel"\n                        aria-labelledby="'+
((__t=( categoryId ))==null?'':__t)+
'-heading"\n                        data-parent="#'+
((__t=( sectionId ))==null?'':__t)+
'-collapse">\n                        <div class="card-body">\n                           ';
 category.interests && category.interests.forEach(function ( interest, index ) { 
__p+='\n                              <div class="form-check d-block ';
 if (index === category.interests.length - 1) { 
__p+=' mb-0 ';
 } 
__p+='">\n                                 <label class="form-check-label">\n                                    <input type="checkbox" name="'+
((__t=( interest.id ))==null?'':__t)+
'" class="form-check-input"\n                                          data-interest-checkbox>\n                                    '+
((__t=( interest.title ))==null?'':__t)+
'\n                                 </label>\n                              </div>\n                              ';
 interest.tags && interest.tags.forEach(function ( tagName, index ) { 
__p+='\n                                    <div class="interest-tags_check form-check';
 if (index === interest.tags.length - 1) { 
__p+=' mb-0 ';
 } 
__p+='">\n                                       <label class="form-check-label">\n                                          <input type="checkbox" name="'+
((__t=( tagName ))==null?'':__t)+
'" class="form-check-input tags-checkbox"\n                                                data-tag-checkbox>\n                                          '+
((__t=( tagName ))==null?'':__t)+
'\n                                       </label>\n                                    </div>\n                              ';
 }) /* end tags */ 
__p+='\n                           ';
 }) /* end interests */ 
__p+='\n                        </div>\n                     </div>\n                  </div>\n\n                  ';
 }) /* end categories */ 
__p+='\n               </div>\n               ';
 section.interests && section.interests.forEach(function ( interest, index ) { 
__p+='\n               <div class="form-check';
 if (index === section.interests.length - 1) { 
__p+=' mb-0 ';
 } 
__p+='">\n                  <label class="form-check-label">\n                     <input type="checkbox" name="'+
((__t=( interest.id ))==null?'':__t)+
'" class="form-check-input"\n                           data-interest-checkbox>\n                     '+
((__t=( interest.title ))==null?'':__t)+
'\n                  </label>\n               </div>\n               ';
 }) /* end interests */ 
__p+='\n            </div>\n            ';
 }) /* end sections */ 
__p+='\n         </div>\n      </div>\n\n      <div class="card-footer d-flex justify-content-end bg-light">\n         <button type="submit" id="signup-submit" class="btn btn-success col-6 col-md-2">\n            <div class="loader"></div>\n            Submit\n         </button>\n      </div>\n   </div>\n</form>\n';
}
return __p;
};
